import "./rooms.css";

import React from "react";
import { Link } from "react-router-dom";

import { ROOM_PAGES, ROUTES } from "../../data/content";
import Lightbox from "../general/Lightbox";
import PageHero from "../general/PageHero";
import PageMeta from "../general/PageMeta";
import Slideshow from "../general/Slideshow";

//Style card: small slideshow with the grey caption box overlapping its bottom edge
const StyleCard = ({ card }) => {
  const [openIndex, setOpenIndex] = React.useState(null);

  return (
    <li className={"style-card"}>
      <div className={"style-card-photos"}>
        <Slideshow
          photos={card.PHOTOS}
          label={`${card.TITLE} photos`}
          variant={"card"}
          sizes={"(max-width: 640px) 100vw, (max-width: 1000px) 50vw, 33vw"}
          onOpen={setOpenIndex}
        />
      </div>
      <div className={"style-card-caption"}>
        <h2 className={"style-card-title"}>{card.TITLE}</h2>
        <p className={"style-card-text"}>{card.TEXT}</p>
      </div>
      <Lightbox
        title={card.TITLE}
        photos={card.PHOTOS}
        index={openIndex}
        onClose={() => setOpenIndex(null)}
      />
    </li>
  );
};

//Kitchens, Bedrooms, Bathrooms & Entertainment Spaces - "room" is the ROOM_PAGES key
const RoomPage = ({ room }) => {
  const page = ROOM_PAGES[room];

  return (
    <React.Fragment>
      <PageMeta
        title={page.META_TITLE}
        description={page.TEXT}
      />
      <PageHero
        photo={page.HERO.PHOTO}
        video={page.HERO.VIDEO}
        poster={page.HERO.POSTER}
      />

      <section className={`intro ${page.WIDE_TEXT ? "has-wide-text" : ""}`}>
        <h1 className={"section-title"}>{page.TITLE}</h1>
        <p className={"body-text"}>{page.TEXT}</p>
        <Link
          to={ROUTES.CONTACT}
          className={"btn is-wide"}
        >
          Get in Touch
        </Link>
      </section>

      <ul className={`style-cards is-${page.CARDS.length}`}>
        {page.CARDS.map((card) => (
          <StyleCard
            key={card.TITLE}
            card={card}
          />
        ))}
      </ul>
    </React.Fragment>
  );
};

export default RoomPage;
